const shortlistLength = 5

export default {
  shortlistLength
}
